import { useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Divider, Input, Select, Space } from 'antd';
import { useSelector } from "react-redux";
import utils from './utils';
import { APIClient } from "../helpers/api_helper";
import { useDispatch } from 'react-redux';
import { loadProjectTypes } from '../slices/thunk';


const api = new APIClient();


const ProjectTypeSelect = ({ value = [], onChange, multiple = false }) => {

  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');

  const opts = utils.processBackendOpts(useSelector((state) => state.ProjectTypes.list))

  const createAndSelectNew = (e) => {

    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;

    const exists = opts.some(opt => opt.value === trimmed);
    if (exists){
      return;
    }

    api.post('/api/project_types/', {'title': trimmed}, {successMsg: `Vrsta projekta ${trimmed} uspešno ustvarjena!`})
      .then(resp => {
        setName('');
        setOpen(false);
        onChange(resp?.id)
        dispatch(loadProjectTypes());  // so redux (app-wide) companies are updated!
      })
  };


  return (
    <Select
      open={open}
      onDropdownVisibleChange={setOpen}
      mode={multiple ? "multiple" : undefined}
      showSearch
      style={{ minWidth: 200, flex: 1 }}
      placeholder="Izberi vrsto projekta"
      optionFilterProp="label"
      value={value} // <-- this must be array of strings (values)
      onChange={onChange}
      options={opts}
      allowClear
      dropdownRender={menu => (
        <>
          {menu}
          <Divider style={{ margin: '8px 0' }} />
          <Space style={{ padding: '0 8px 4px' }}>
            <Input
              placeholder="Vnesi novo vrsto projekta"
              ref={inputRef}
              value={name}
              onChange={e => setName(e.target.value)}
              onKeyDown={e => e.stopPropagation()}
            />
            <Button type="text" icon={<PlusOutlined />} onClick={createAndSelectNew}>
              Ustvari novo vrsto projekta
            </Button>
          </Space>
        </>
      )}
    />
  );
};

export default ProjectTypeSelect;
